/**
 * Поиск по статическому списку вариантов — общий для `Combobox` и всех, кто
 * фильтрует справочник на клиенте (языки, кабинеты, страны).
 */
/**
 * Ключ сравнения: без регистра, без диакритики («Español» ищется по
 * «espanol», «Ångström» по «angstrom»), «ё» = «е», пробелы схлопнуты.
 */
export function normalizeSearchText(text) {
    return text
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLocaleLowerCase('ru-RU')
        .replace(/ё/g, 'е')
        .replace(/\s+/g, ' ')
        .trim();
}
function wordStarts(haystack, needle) {
    if (haystack.startsWith(needle))
        return true;
    return haystack.split(/[^\p{L}\p{N}]+/u).some((w) => w.startsWith(needle));
}
/**
 * Варианты, подходящие под запрос, — по подписи, значению (коду), словам
 * `keywords` и пояснению. Порядок: точное совпадение значения или подписи →
 * подпись начинается с запроса → с запроса начинается слово подписи, значение
 * или ключевое слово → подстрока где угодно. Внутри группы — исходный порядок
 * (справочник уже отсортирован так, как его привыкли видеть). Пустой запрос —
 * весь список как есть.
 */
export function searchOptions(options, query) {
    const q = normalizeSearchText(query);
    if (q === '')
        return [...options];
    const ranked = [];
    options.forEach((option, index) => {
        const label = normalizeSearchText(option.label);
        const value = normalizeSearchText(option.value);
        const keywords = (option.keywords ?? []).map(normalizeSearchText);
        const description = option.description ? normalizeSearchText(option.description) : '';
        let rank;
        if (value === q || label === q || keywords.includes(q))
            rank = 0;
        else if (label.startsWith(q))
            rank = 1;
        else if (wordStarts(label, q) || value.startsWith(q) || keywords.some((k) => wordStarts(k, q)))
            rank = 2;
        else if (label.includes(q) ||
            value.includes(q) ||
            keywords.some((k) => k.includes(q)) ||
            description.includes(q))
            rank = 3;
        else
            return;
        ranked.push({ option, rank, index });
    });
    ranked.sort((a, b) => a.rank - b.rank || a.index - b.index);
    return ranked.map((r) => r.option);
}
//# sourceMappingURL=option-search.js.map